var _path, _path2, _circle, _circle2, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateCurvedLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 217,
    viewBox: "0 0 558 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.986 11.4401C427.385 11.4401 403.592 4.75574 363.618 95.1946C335.381 159.08 299.071 210.356 257.021 210.356C216.096 210.356 165.167 127.266 127.583 59.9642C86.6574 -13.3213 26.583 5.02753 0.999481 29.5016",
    stroke: "#ECEFF8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.05 8.56641H556.822",
    stroke: "#ECEFF8",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75877,
    cy: 4.75877,
    r: 4.75877,
    transform: "matrix(-1 0 0 1 356.004 3.80664)",
    fill: "#FFCC00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75877,
    cy: 4.75877,
    r: 4.75877,
    transform: "matrix(-1 0 0 1 557.775 3.80664)",
    fill: "#FFCC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.1316,
    height: 17.1316,
    transform: "matrix(-1 0 0 1 268.443 199.868)",
    fill: "#FFCC00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.1316,
    height: 17.1316,
    transform: "matrix(-1 0 0 1 462.6 0)",
    fill: "#FFCC00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17.1316,
    height: 17.1316,
    transform: "matrix(-1 0 0 1 59.0566 0)",
    fill: "#FFCC00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCurvedLine);
export default __webpack_public_path__ + "static/media/update-curved-line.d17c62248d589a0aa9c9840eaf1881c1.svg";
export { ForwardRef as ReactComponent };